export default __webpack_public_path__ + "static/media/divider-cutout.4c93fdc5.svg";